import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/ProjectWorkflowFoundation"
    : "SLN/SolarentOperator/ProjectWorkflowFoundation";

const unwrapPayload = (res) => res?.data ?? res ?? null;

const ProjectMilestoneCoordinationApi = {
  getCoordinationByPlan: async (source, projectExecutionPlanId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetMilestoneCoordinationByPlan?projectExecutionPlanId=${encodeURIComponent(projectExecutionPlanId)}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  getCoordinationByMilestone: async (source, milestoneId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetMilestoneCoordinationByMilestone?milestoneId=${encodeURIComponent(milestoneId)}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  evaluatePlanCoordination: async (source, projectExecutionPlanId) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/EvaluatePlanCoordination?projectExecutionPlanId=${encodeURIComponent(projectExecutionPlanId)}`,
      {}
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },
};

export default ProjectMilestoneCoordinationApi;
